/* eslint-disable */
import Vue from 'vue';
import ShardsVue from 'shards-vue';
import VueAnalytics from 'vue-analytics';
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap'

// Styles
import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/theme/s2p-dashboard.scss';
import '@/assets/scss/date-range.scss';

// Core
import App from './App.vue';
import router from './router';
import store from './store';

// Layouts
import Default from '@/layouts/Default.vue';
import HeaderNavigation from '@/layouts/HeaderNavigation.vue';
import IconSidebar from '@/layouts/IconSidebar.vue';

//Utils Vue
import "./vee-validate";
import VueCurrencyInput from 'vue-currency-input'
import VueMoment from 'vue-moment'
import VueTheMask from 'vue-the-mask'

// Plugin Utils
import './utils/filters.js'
import msgbox from './utils/msgBox.js'
import requestGetCommissionCompetence from './utils/requestGetCommissionCompetence.js'
import sessionStoreAuth from './utils/sessionStoreAuth.js'
import toast from './utils/toast.js'

// Custom Components
import Loader from './components/common/Loader.vue'

import VueMonthlyPicker from 'vue-monthly-picker'

const isProd = process.env.NODE_ENV === 'production';

ShardsVue.install(Vue);

Vue.use(BootstrapVue)
Vue.use(VueMoment)
Vue.use(VueTheMask)
Vue.use(msgbox)
Vue.use(requestGetCommissionCompetence)
Vue.use(sessionStoreAuth);
Vue.use(toast)

Vue.component('Loader', Loader);
Vue.component('default-layout', Default);
Vue.component('header-navigation-layout', HeaderNavigation);
Vue.component('icon-sidebar-layout', IconSidebar);
Vue.component('vue-monthly-picker', VueMonthlyPicker);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: 'BRL',
    distractionFree: false
  }
})

// Analytics
Vue.use(VueAnalytics, {
  id: isProd ? 'UA-115105611-1' : 'UA-115105611-2',
  router
});

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js